import React, { useState } from 'react';
import Navbar from './component/Navbar';
import Footer from './component/Footer';

const TeamPage = () => {
  const [filter, setFilter] = useState('all');

  const teamMembers = [
    {
      name: 'Dev Datta',
      role: 'Co-Founder & Chief Executive Officer - Interim',
      category: 'executive',
      categoryLabel: 'EXECUTIVE BOARD',
      image: '/assets/images/team/dev-datta.webp',
      linkedin: 'https://www.linkedin.com/in/dev-datta-38637017',
      bio: 'Pioneering technology strategy and enterprise SaaS expansion across international markets.',
      highlight: '#00D4FF',
    },
    {
      name: 'Joydip Lahiri',
      role: 'Independent Director & Blockchain Architect',
      category: 'executive',
      categoryLabel: 'EXECUTIVE BOARD',
      image: '/assets/images/team/jaydip.webp',
      linkedin: 'https://www.linkedin.com/in/joydip-lahiri-a7112117',
      bio: 'Expert in distributed ledger technologies, smart contracts, and secure enterprise data provenance.',
      highlight: '#6C63FF',
    },
    {
      name: 'Babulal Nolkha',
      role: 'Chartered Accountant & Compliance Officer',
      category: 'executive',
      categoryLabel: 'EXECUTIVE BOARD',
      image: '/assets/images/team/babulal.webp',
      linkedin: 'https://www.linkedin.com/in/babulal-nolkha-78450b105',
      bio: 'Overseeing global financial governance, audit frameworks, and fintech regulatory compliance.',
      highlight: '#10B981',
    },
    {
      name: 'Amitava Roy Chowdhoury',
      role: 'Director & Chief Technology Officer',
      category: 'tech',
      categoryLabel: 'ENGINEERING & AI',
      image: '/assets/images/team/amitava.webp',
      linkedin: 'https://www.linkedin.com/in/amitava-roy-chowdhoury-4306a432',
      bio: 'Leading core cloud architecture, microservices infrastructure, and AI engineering pipelines.',
      highlight: '#38BDF8',
    },
    {
      name: 'Sougata Majumder',
      role: 'Product Experience & Design - Mentor',
      category: 'tech',
      categoryLabel: 'ENGINEERING & AI',
      image: '/assets/images/team/sougata.webp',
      linkedin: 'https://www.linkedin.com/in/sougatam',
      bio: 'Crafting intuitive UI/UX standards and human-centered design for enterprise applications.',
      highlight: '#A78BFA',
    },
    {
      name: 'Moumita Biswas',
      role: 'Director & Human Resource Head',
      category: 'executive',
      categoryLabel: 'EXECUTIVE BOARD',
      image: '/assets/images/team/moumita.webp',
      linkedin: 'https://www.linkedin.com/in/moumita-biswas',
      bio: 'Driving global talent acquisition, organizational culture, and engineering team operations.',
      highlight: '#EC4899',
    },
    {
      name: 'Rajnikant Patel',
      role: 'Board Mentor & Strategic Advisor',
      category: 'mentor',
      categoryLabel: 'STRATEGIC ADVISOR',
      image: '/assets/images/team/rajnikant.webp',
      linkedin: 'https://www.linkedin.com/in/rajnickantpatel',
      bio: 'Senior advisor guiding corporate governance, ecosystem partnerships, and global scale.',
      highlight: '#F59E0B',
    },
    {
      name: 'Gurunath Mudlapur',
      role: 'Corporate Advisor & Mentor',
      category: 'mentor',
      categoryLabel: 'STRATEGIC ADVISOR',
      image: '/assets/images/team/gurunath.webp',
      linkedin: 'https://www.linkedin.com/in/gurunath-mudlapur-6a670a',
      bio: 'Vast expertise in capital markets, strategic growth, and institutional enterprise expansion.',
      highlight: '#34D399',
    },
    {
      name: 'Eman Kalyan Ghosh',
      role: 'Founder & Collaborator',
      category: 'executive',
      categoryLabel: 'EXECUTIVE BOARD',
      image: '/assets/images/team/eman_kalyan.webp',
      linkedin: 'https://www.linkedin.com/in/eman-kalyan-ghosh-564a2618',
      bio: 'Pioneered early product vision and collaborative technology frameworks for Hungry Top.',
      highlight: '#00D4FF',
    },
    {
      name: 'Ashutosh Mishra',
      role: 'Business Strategy Head',
      category: 'executive',
      categoryLabel: 'EXECUTIVE BOARD',
      image: '/assets/images/team/asutosh.webp',
      linkedin: 'https://www.linkedin.com/in/ashutosh-mishra-3240b68',
      bio: 'Spearheading business development, key account management, and enterprise partnerships.',
      highlight: '#818CF8',
    },
    {
      name: 'Devendra Tripathi',
      role: 'Technology & Growth Mentor',
      category: 'mentor',
      categoryLabel: 'STRATEGIC ADVISOR',
      image: '/assets/images/team/devendra.webp',
      linkedin: 'https://www.linkedin.com/in/devendra-tripathi-46617b',
      bio: 'Guiding engineering scalability, cloud infrastructure readiness, and market positioning.',
      highlight: '#F472B6',
    },
    {
      name: 'Dr. Indranil Nandi',
      role: 'Research & Innovation Mentor',
      category: 'mentor',
      categoryLabel: 'STRATEGIC ADVISOR',
      image: '/assets/images/team/indranil.webp',
      linkedin: 'https://www.linkedin.com/in/indranilnandi',
      bio: 'Focusing on advanced R&D, algorithmic efficiency, and emerging technology integration.',
      highlight: '#38BDF8',
    },
    {
      name: 'Rajesh Sarma',
      role: 'Enterprise Advisory Partner',
      category: 'mentor',
      categoryLabel: 'STRATEGIC ADVISOR',
      image: '/assets/images/team/Rajesh_Sarma.webp',
      linkedin: 'https://www.linkedin.com/company/hungrytop',
      bio: 'Providing strategic direction for enterprise client integrations and global expansion.',
      highlight: '#10B981',
    },
    {
      name: 'Anirban Das',
      role: 'Lead Cloud Infrastructure Architect',
      category: 'tech',
      categoryLabel: 'ENGINEERING & AI',
      image: '/assets/images/team/anirban.webp',
      linkedin: 'https://www.linkedin.com/company/hungrytop',
      bio: 'Architecting ultra-low latency DevOps microservices and resilient Kubernetes clusters.',
      highlight: '#A78BFA',
    },
  ];

  const filteredMembers = filter === 'all' 
    ? teamMembers 
    : teamMembers.filter(m => m.category === filter);

  return (
    <div style={{ backgroundColor: '#060816', color: '#FFFFFF', minHeight: '100vh', position: 'relative' }}>
      {/* Navigation Header */}
      <Navbar onOpenConsultation={() => (window.location.href = '/contact')} />

      {/* Main Content Container */}
      <main style={{ paddingTop: '78px', paddingBottom: '50px' }}>
        <div className="ht-container">
          
          {/* Header Section */}
          <div className="section-header" style={{ textAlign: 'center', marginBottom: '24px' }}>
            <span
              style={{
                background: 'rgba(0, 212, 255, 0.12)',
                color: '#00D4FF',
                padding: '5px 14px',
                borderRadius: '20px',
                fontSize: '0.75rem',
                fontWeight: 800,
                letterSpacing: '1.2px',
                border: '1px solid rgba(0, 212, 255, 0.3)',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '12px',
              }}
            >
              <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#00D4FF', boxShadow: '0 0 10px #00D4FF' }}></span>
              THE LEADERSHIP & MENTORS
            </span>

            <h1 className="text-gradient" style={{ fontSize: 'clamp(2rem, 3.8vw, 3.2rem)', fontWeight: 900, margin: '6px 0 12px 0', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Meet the Minds Shaping Hungry Top
            </h1>

            <p style={{ color: '#A3A8B8', fontSize: '1rem', maxWidth: '750px', margin: '0 auto', lineHeight: 1.5, fontFamily: "'Inter', sans-serif" }}>
              Our executive board, senior engineering architects, and strategic advisors bring decades of international experience across enterprise software, artificial intelligence, and fintech.
            </p>

            {/* Quick Stats Grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '12px',
                maxWidth: '640px',
                margin: '20px auto 24px auto',
                padding: '12px 16px',
                background: 'rgba(15, 23, 42, 0.7)',
                borderRadius: '16px',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                backdropFilter: 'blur(16px)',
              }}
              className="team-stats-grid"
            >
              <div style={{ textAlign: 'center' }}>
                <span style={{ fontSize: '1.5rem', fontWeight: 900, color: '#00D4FF', display: 'block', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>14+</span>
                <span style={{ fontSize: '0.72rem', color: '#94A3B8', fontWeight: 600 }}>Leaders & Advisors</span>
              </div>
              <div style={{ textAlign: 'center', borderLeft: '1px solid rgba(255, 255, 255, 0.08)', borderRight: '1px solid rgba(255, 255, 255, 0.08)' }}>
                <span style={{ fontSize: '1.5rem', fontWeight: 900, color: '#A78BFA', display: 'block', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>25+ Yrs</span>
                <span style={{ fontSize: '0.72rem', color: '#94A3B8', fontWeight: 600 }}>Combined Experience</span>
              </div>
              <div style={{ textAlign: 'center' }}>
                <span style={{ fontSize: '1.5rem', fontWeight: 900, color: '#10B981', display: 'block', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>Global</span>
                <span style={{ fontSize: '0.72rem', color: '#94A3B8', fontWeight: 600 }}>Enterprise Reach</span>
              </div>
            </div>

            {/* Filter Tabs */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
              {[
                { id: 'all', label: `All Leadership (${teamMembers.length})` },
                { id: 'executive', label: 'Executive Board' },
                { id: 'tech', label: 'Engineering & AI' },
                { id: 'mentor', label: 'Mentors & Advisors' },
              ].map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setFilter(tab.id)}
                  style={{
                    padding: '9px 22px',
                    borderRadius: '9999px',
                    border: filter === tab.id ? '1px solid rgba(0, 212, 255, 0.8)' : '1px solid rgba(255, 255, 255, 0.1)',
                    background: filter === tab.id ? 'linear-gradient(135deg, rgba(0, 212, 255, 0.25) 0%, rgba(108, 99, 255, 0.25) 100%)' : 'rgba(255, 255, 255, 0.03)',
                    color: filter === tab.id ? '#00D4FF' : '#94A3B8',
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    cursor: 'pointer',
                    fontFamily: "'Plus Jakarta Sans', sans-serif",
                    transition: 'all 0.25s ease',
                    boxShadow: filter === tab.id ? '0 4px 15px rgba(0, 212, 255, 0.25)' : 'none',
                  }}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>

          {/* Team Grid */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(3, 1fr)',
              gap: '20px',
            }}
            className="team-members-grid"
          >
            {filteredMembers.map((member, idx) => (
              <article
                key={idx}
                className="glass-card"
                style={{
                  borderRadius: '24px',
                  padding: '30px 24px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  border: '1px solid rgba(255, 255, 255, 0.08)',
                  background: 'rgba(15, 23, 42, 0.75)',
                  backdropFilter: 'blur(20px)',
                  WebkitBackdropFilter: 'blur(20px)',
                  transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = member.highlight;
                  e.currentTarget.style.transform = 'translateY(-6px)';
                  e.currentTarget.style.boxShadow = `0 20px 40px rgba(0, 0, 0, 0.6), 0 0 30px ${member.highlight}33`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.08)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}
              >
                <div>
                  {/* Category Pill Badge */}
                  <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                    <span
                      style={{
                        fontSize: '0.66rem',
                        fontWeight: 800,
                        color: member.highlight,
                        background: 'rgba(255, 255, 255, 0.04)',
                        border: `1px solid ${member.highlight}50`,
                        padding: '3px 10px',
                        borderRadius: '12px',
                        letterSpacing: '0.8px',
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                      }}
                    >
                      {member.categoryLabel}
                    </span>
                  </div>

                  {/* Avatar Container with Gradient Outer Ring */}
                  <div
                    style={{
                      width: '112px',
                      height: '112px',
                      margin: '0 auto 20px auto',
                      position: 'relative',
                      borderRadius: '50%',
                      padding: '3px',
                      background: `linear-gradient(135deg, ${member.highlight} 0%, #6C63FF 100%)`,
                      boxShadow: `0 0 20px ${member.highlight}40`,
                    }}
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      loading="lazy"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?auto=format&fit=crop&w=300&q=80';
                      }}
                      style={{
                        width: '100%',
                        height: '100%',
                        borderRadius: '50%',
                        objectFit: 'cover',
                        display: 'block',
                        background: '#0F172A',
                      }}
                    />
                  </div>

                  {/* Name & Role */}
                  <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                    <h3 style={{ fontSize: '1.25rem', color: '#FFFFFF', fontWeight: 800, marginBottom: '8px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                      {member.name}
                    </h3>
                    <span
                      style={{
                        fontSize: '0.8rem',
                        fontWeight: 700,
                        color: '#00D4FF',
                        background: 'rgba(0, 212, 255, 0.1)',
                        border: '1px solid rgba(0, 212, 255, 0.25)',
                        padding: '4px 12px',
                        borderRadius: '16px',
                        display: 'inline-block',
                        lineHeight: 1.4,
                        fontFamily: "'Plus Jakarta Sans', sans-serif",
                      }}
                    >
                      {member.role}
                    </span>
                  </div>

                  {/* Bio Description */}
                  <p style={{ fontSize: '0.88rem', color: '#A3A8B8', textAlign: 'center', lineHeight: 1.6, marginBottom: '24px', fontFamily: "'Inter', sans-serif" }}>
                    {member.bio}
                  </p>
                </div>

                {/* LinkedIn Link Button */}
                <div style={{ textAlign: 'center', paddingTop: '16px', borderTop: '1px solid rgba(255, 255, 255, 0.06)' }}>
                  <a
                    href={member.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '8px',
                      color: '#A78BFA',
                      fontSize: '0.82rem',
                      fontWeight: 700,
                      textDecoration: 'none',
                      padding: '8px 18px',
                      borderRadius: '12px',
                      background: 'rgba(139, 92, 246, 0.12)',
                      border: '1px solid rgba(139, 92, 246, 0.3)',
                      transition: 'all 0.25s ease',
                      fontFamily: "'Plus Jakarta Sans', sans-serif",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.color = '#FFFFFF';
                      e.currentTarget.style.background = '#6C63FF';
                      e.currentTarget.style.borderColor = '#6C63FF';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.color = '#A78BFA';
                      e.currentTarget.style.background = 'rgba(139, 92, 246, 0.12)';
                      e.currentTarget.style.borderColor = 'rgba(139, 92, 246, 0.3)';
                    }}
                  >
                    <i className="fab fa-linkedin" style={{ fontSize: '0.95rem' }}></i>
                    <span>Connect on LinkedIn</span>
                  </a>
                </div>
              </article>
            ))}
          </div>

          {/* Join Team Callout Card */}
          <div
            className="glass-card"
            style={{
              marginTop: '64px',
              padding: '48px',
              borderRadius: '32px',
              textAlign: 'center',
              background: 'linear-gradient(135deg, rgba(108, 99, 255, 0.2) 0%, rgba(0, 212, 255, 0.15) 100%)',
              border: '1px solid rgba(108, 99, 255, 0.4)',
              boxShadow: '0 20px 50px rgba(0, 0, 0, 0.5)',
            }}
          >
            <h2 style={{ fontSize: '2rem', color: '#FFF', fontWeight: 900, marginBottom: '12px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Want to Join Our Leadership & Engineering Team?
            </h2>
            <p style={{ color: '#E2E8F0', fontSize: '1.05rem', maxWidth: '640px', margin: '0 auto 28px auto', fontFamily: "'Inter', sans-serif" }}>
              We are constantly seeking visionary software architects, AI researchers, and fintech innovators to build next-generation software platforms.
            </p>
            <a
              href="/careers"
              className="btn-primary-gradient"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '12px 32px',
                borderRadius: '30px',
                fontSize: '0.92rem',
                fontWeight: 800,
                textDecoration: 'none',
              }}
            >
              <span>Explore Open Roles</span>
              <i className="fas fa-arrow-right"></i>
            </a>
          </div>

        </div>
      </main>

      {/* Footer */}
      <Footer />

      {/* Responsive Styles Injection */}
      <style>{`
        @media (max-width: 1024px) {
          .team-members-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 640px) {
          .team-members-grid {
            grid-template-columns: 1fr !important;
          }
          .team-stats-grid {
            grid-template-columns: 1fr !important;
            gap: 12px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default TeamPage;
